
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.33366 12.6684H8.00033V1.1817C8.00044 1.12611 7.98666 1.07137 7.96022 1.02246C7.93378 0.97356 7.89553 0.932046 7.84895 0.901699C7.80237 0.871353 7.74894 0.853138 7.69352 0.848714C7.63811 0.844289 7.58246 0.853795 7.53166 0.876366L2.39633 3.15903C2.27845 3.2114 2.17829 3.29684 2.108 3.405C2.03771 3.51315 2.00031 3.63938 2.00033 3.76837V12.6684H0.666992V14.0017H15.3337V12.6684H14.0003V6.4417C14.0004 6.31114 13.9622 6.18342 13.8904 6.07438C13.8186 5.96535 13.7163 5.87981 13.5963 5.82836L9.33366 4.0017V12.6684ZM3.66895 5.03906V6.3724H6.33561V5.03906H3.66895ZM3.66895 7.70573V9.03906H6.33561V7.70573H3.66895Z"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Organize',
    }) as DefineComponent
    </script>
    